import { getPaymentAnalysisReport } from "@/api/report-api";
import { buildCacheKey, useCollectionData } from "@/hooks/use-api";
import { PaymentAnalysisResponse } from "@/types/report-type";

export function usePaymentAnalysis(fromDate: string, toDate: string) {
    const cacheKey = buildCacheKey("payment-analysis", { fromDate, toDate });

    return useCollectionData<PaymentAnalysisResponse>(
        cacheKey,
        () => getPaymentAnalysisReport(fromDate, toDate),
        {
            refreshInterval: 0,
            revalidateOnFocus: false,
        }
    );
}
